import React, {PureComponent} from 'react'
import Store from 'Store'
import {inject, observer} from 'mobx-react'
import history from 'helpers/History'
import {Table} from 'components'
import {loading} from 'elements/Loading'
import Device from '../Model'
import {toDate} from '../../../helpers/Format'

interface Props {
  store?: Store
  devices: Device[]
}

@inject('store')
@loading<Props>(props => {
  return [
    props.store!.devices.read().then(devices => ({devices})),
  ]
})
@observer
export default class DevicesTable extends PureComponent<Props, object> {

  componentDidMount(): void {
    console.log('componentDidMount')

  }

  handleSelectItem = (value: Device) => {
    const deviceFiltered = this.props.devices.filter(device => device.id === value.id)
    console.log(deviceFiltered)
  }

  render() {
    const {devices} = this.props
    const mapeados = devices.map(value => {
      const temp: any = {...value}
      temp.license = value.license.key
      temp.validoHasta = toDate(new Date(value.license.valid))
      const caducado = (new Date(value.license.valid)).getTime() <= Date.now()
      temp.state = caducado? 'licencia caducada': value.blocked_at? 'bloqueado' : value.disabled_at ? 'No activo' : 'activo'
      temp.disabled_at = caducado? toDate(new Date(value.license.valid)) : value.blocked_at? toDate(new Date(value.blocked_at)) : value.disabled_at? toDate(new Date(value.disabled_at)) : ''
      return temp
    })
    const headers = ['terminalnumero', 'license', 'validoHasta', 'serial', 'model', 'manufacturer', 'brand', 'state', 'disabled_at']

    if (!(devices.length > 0))
      return <div><p>No hay dispositivos dados de alta</p> </div>

    return (
      <Table
        items={mapeados}
        header={headers}
        onSelectItem={this.handleSelectItem}
        keyExtractor={(item: Device) => String(item.id)}
        loading={devices===undefined}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Devices/container/DevicesTable.tsx